import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const StoreHeader = styled.div`
  padding: 16px 32px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 20px;
    gap: 12px;
  }
`;

export const StoreTitle = styled.h1`
  font-size: 24px;
  line-height: 1.5rem;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 0;
  flex-shrink: 0;

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 20px;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;
  min-width: 0;
  margin-right: 32px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    flex: none;
    width: 100%;
    max-width: none;
    margin-right: 0;
    min-width: auto;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.palette.grey63};
  display: flex;
  align-items: center;
  pointer-events: none;

  svg {
    width: 20px;
    height: 20px;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    left: 12px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    left: 10px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 1px solid ${DEFAULT_COLORS.surface.light};
  border-radius: 5px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.white};
  transition: all 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.palette.primary};
    box-shadow: 0 0 0 3px ${DEFAULT_COLORS.primaryFocusRing};
  }

  &::placeholder {
    color: ${({ theme }) => theme.palette.grey44};
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 10px 12px 10px 40px;
    font-size: 14px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 8px 12px 8px 36px;
    font-size: 13px;
  }
`;
